import { useLocation } from "react-router-dom";

import { useIsEmployeeAuthenticated } from "~/providers/store/employee";
import { T } from "@repo/transifex";
import { ApiErrorCodesEnum, isApiError } from "~/api/error";
import { ScannerListener, scanToastError } from "~/components/scanner-listener";
import { useDiningOption } from "~/providers/store/basket/hooks/use-basket";
import { useIdentifyUser } from "~/hooks/use-identify-user";

import { canScan } from "./can-scan";
import {
  ProductOutOfStockError,
  ProductStockLimitReachedError,
  useFindProduct
} from "./use-find-product";

export const PosScannerListener = () => {
  const { pathname } = useLocation();

  const isAuthenticated = useIsEmployeeAuthenticated();
  const diningOption = useDiningOption();

  const { mutate: findProduct } = useFindProduct();
  const { mutate: identifyUser } = useIdentifyUser();

  return (
    <ScannerListener
      isUserAuthenticated={isAuthenticated}
      enabled={canScan(pathname)}
      onIdentifyProductOrUser={(value) => {
        findProduct(value, {
          onError: (error) => {
            if (
              error instanceof ProductOutOfStockError ||
              error instanceof ProductStockLimitReachedError
            ) {
              return;
            }
            if (isAuthenticated) {
              scanToastError(null, <T _str="Barcode not registered" />);
            }

            identifyUser(
              {
                userIdentifier: { type: "child-card-hex", value },
                diningOption
              },
              {
                onError: (error) => {
                  scanToastError(
                    isApiError(error) &&
                      error.body.code === ApiErrorCodesEnum.CHILD_NOT_FOUND
                      ? null
                      : error
                  );
                }
              }
            );
          }
        });
      }}
      onIdentifyUser={(value) => {
        identifyUser(
          { userIdentifier: value, diningOption },
          {
            onError: (error) => {
              scanToastError(error);
            }
          }
        );
      }}
    />
  );
};
